export const ATTACHMENT_PENDING_UPLOAD_STATUS = "PENDING_UPLOAD";
export const ATTACHMENT_UPLOADED_STATUS = "UPLOADED";